import axios from "axios";

import Config from "src/config";

const v2_actionEditarTag = (tagId, data) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/chats/tags/${tagId}/editar`,
        data
    });
};
export default v2_actionEditarTag;
